export default "/images/3cd8069010381cedc4952f9d47d620f3.avif";